(() => {
  function buildTitleQuery(raw) {
    return raw
      .trim()
      .split(/\s+/)
      .map((word) => word.replace(/[\\():*"']/g, ''))
      .filter(Boolean)
      .map((word) => `title:${word}*`)
      .join(' AND ');
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;

    if (
      !(form instanceof HTMLFormElement) ||
      !form.matches('form[action*="/search"]')
    ) {
      return;
    }

    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    const raw = input.value.trim();
    if (!raw || raw.includes('title:')) return;

    input.value = buildTitleQuery(raw);
  });
})();